import { Helmet } from "react-helmet";
import { useAccount } from "../store/account";

export default function Help() {
    const { data: account = {} } = useAccount();
    return (
        <>
            <Helmet>
                <title>Office Hours Schedule - Podtrac</title>
            </Helmet>
            <h1>Office Hours</h1>
            <p>
                To schedule a 1:1 call with a Podtrac support expert, email{" "}
                <b>
                    <a href="mailto:support@podtrac.com" target="_blank">
                        support@podtrac.com
                    </a>
                </b>{" "}
                from an email address associated with your paid Grow Your Show account.
            </p>
            <p>
                If you need immediate support, please email our support desk at{" "}
                <b>
                    <a href="mailto:support@podtrac.com" target="_blank">
                        support@podtrac.com
                    </a>
                </b>{" "}
                with the details of your question.
            </p>
        </>
    );
}
